import React, { Fragment } from 'react';
import EmailIcon from '@mui/icons-material/Email';
import '../Style/ComunicationEmail.css';




function ComunicationEmail() {
  return (
    <Fragment> 
        <div className='comunicationEmailGeneral'>
            <div className='emailStyle emailPosition' >
                <a href="mailto:info@emlakcinn.com" ><EmailIcon className='emailEmail'/></a>
            </div>
        </div> 
    </Fragment>
      

  )
}

export default ComunicationEmail;